import React from 'react'
import { Link } from 'react-router'

const ListHeaderNav = ({ title, link = "/", text = "トップへ戻る" }) => (
  <div className="list-header__nav">
    <Link to={link}>&lt; {text}</Link>
  </div>
)

export default ListHeaderNav



// WEBPACK FOOTER //
// ./src/components/ListHeaderNav.js